import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import BlkBlockLanding from "./BlkBlockLanding";
import ThankYou from "./ThankYou";
import Landing from "./Landing"; // Teyori Landing
import ClothingLanding from "./ClothingLanding";
import BooksLanding from "./BooksLanding";
import ConceptPage from "./Concept";
import { DonatePage } from "./Donate";
import Directory from "./Directory.jsx";

function NotFound() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-black text-neutral-100">
      <div className="text-center px-6">
        <h1 className="text-3xl font-bold">Page not found</h1>
        <p className="mt-2 text-neutral-400">Let’s head back to the Blk Bloc.</p>
        <a
          href="/"
          className="inline-block mt-4 rounded-2xl px-5 py-3 bg-white text-black hover:bg-neutral-200"
        >
          Go Home
        </a>
      </div>
    </main>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Redirect root to main Blk Bloc page */}
        <Route path="/" element={<Navigate to="/TheBlkBloc" replace />} />

        {/* Main pages */}
        <Route path="/TheBlkBloc" element={<BlkBlockLanding />} />
        <Route path="/concept" element={<ConceptPage />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/clothing" element={<ClothingLanding />} />
        <Route path="/teyori" element={<Landing />} />
        <Route path="/books" element={<BooksLanding />} />
        <Route path="/ThankYou" element={<ThankYou />} />
        <Route path="/directory" element={<Directory />} />

        {/* Fallback */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
